// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__zaDPC","header":"Table_header__oETEd","row":"Table_row__v43B_"};